module.exports = __webpack_public_path__ + "static/img/charging_indicator.c4fe659.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_se_2021/charging_indicator.png
// module id = aUxL
// module chunks = 1